import { Box, styled } from '@mui/material';
import { Link } from '~/components/link';

export const ShowCardContainer = styled(Box)(() => ({ display: 'flex' }));

export const ShowCardChildren = styled(Box)(() => ({ alignItems: 'center', display: 'flex' }));

export const ShowCardLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(1, 0),
  textDecoration: 'none',
}));

export const ShowCardNotLink = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(1, 0),
}));

export const ShowCardIconContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  padding: theme.spacing(1),
  width: '50px',
}));

export const ShowCardMetaContainer = styled(Box)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
}));
